import { memo } from 'react';
import { useLocation } from 'react-router-dom';
import { RoutePath } from 'consts/RoutePath';
import { useStore } from 'store/StoreContext';

export const Footer = memo(() => {
	const [store] = useStore(); // eslint-disable-line
	const location = useLocation();
	const isCommonLoginPage = RoutePath.COMMON_LOGIN === location.pathname;
	const isAgreementEnPage = RoutePath.AGREEMENT_EN === location.pathname;

	return (
		<footer>
			{/* ログイン画面以外 またはV1 またはログイン画面かつフッター表示ONなら表示 かつ英語規約ページ以外を追加*/}
			{(!isCommonLoginPage ||
				!store.authorizeV2Data.client_id ||
				(isCommonLoginPage && store.loginDisplayItemData.footer_display_flg === 1)) &&
			!isAgreementEnPage ? (
				<div className="footer-in">
					<ul>
						<li>
							<a href="https://gakken-ps.co.jp/" target="_blank">
								企業情報
							</a>
						</li>
						<li>
							<a href="/agreement" target="_blank">
								GakkenID規約
							</a>
						</li>
						<li>
							<a href="https://gakken-ps.co.jp/privacypolicy/" target="_blank">
								個人情報について
							</a>
						</li>
						<li>
							<a href="https://gakken-ps.co.jp/privacypolicy/announce/" target="_blank">
								「個人情報の保護に関する法律」に基づく公表事項
							</a>
						</li>
						<li>
							<a href="https://gakken-ps.co.jp/sitepolicy/" target="_blank">
								サイトご利用にあたって
							</a>
						</li>
						<li>
							<a href="faq.html">よくあるご質問</a>
						</li>
						<li>
							<a
								href="https://contact.gakken.jp/user/op_enquete.gsp?sid=1035&mid=000111yf&hid=i0D6Wk2R4_0"
								target="_blank"
							>
								お問い合わせ
							</a>
						</li>
					</ul>
				</div>
			) : null}
			<div className="copy">
				<span>&copy; Gakken</span>
			</div>
		</footer>
	);
});
